export enum Language {
    SLOVENIAN = 'sl',
    ENGLISH = 'en',
    CROATIAN = 'hr'
}
